module.exports = __webpack_public_path__ + "static/media/Discovery-Target.5ee82051.svg";